














import { Tabs, Tab, Sticky } from 'vant'
import { Component, Vue, Prop, Watch, Inject } from 'vue-property-decorator'
import SearchBusiness from './search_business.vue'
import SearchProduct from './search_product.vue'
import { getDistrictListByCityCode } from '../../home-service'
import { getSelectedCityId } from '@utils/index'

@Component({
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Sticky.name]: Sticky,
    SearchBusiness,
    SearchProduct,
  },
})
export default class SearchTab extends Vue {
  @Prop({ default: false }) readonly isRecover!: boolean
  @Prop() readonly tabKey!: number //监听变化 重新获取stickyForHeight
  @Prop() readonly location!: any
  @Prop({ default: '' }) readonly category!: string
  @Prop({ default: '' }) readonly query!: string //产康选择itemtype的值
  @Prop() readonly stickyTop!: number //van-tabs吸顶的offsettop值 必须要传

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_tab')
  clickid_tab!: string

  normalColor = 'transparent' //没有吸顶的背景色  吸顶后背景变成白色
  tabSelect = 0 //tab索引
  stickyTopForClassifyHeight = 0 // 分类排序的吸顶需要的offsettop值
  stickyForHeight = 0 //选择品类/区域 先吸顶在弹框选择 tab想要吸顶 必须知道tab的高度和titleBar的高度  拿当前坐标减去两者的高度
  districtList = [] //区域列表
  tabHeight = 0 //tab的高度
  isFixed = false //是否吸顶
  scrollTopNoFix = 0 //没有吸顶的最大滑动高顿

  async created() {
    this.districtList = await getDistrictListByCityCode()
  }

  mounted() {
    const rect = this.$el.getBoundingClientRect()
    this.tabHeight = rect.height
    this.stickyTopForClassifyHeight = this.stickyTop + this.tabHeight //必须加上一个tabs
    this.stickyForHeight = rect.top - this.stickyTop + 2 //  给个1个高度的误差 使其吸顶 无影响
    setTimeout(() => {
      this.getTabKey()
    }, 200)
  }

  @Watch('tabKey')
  getTabKey() {
    const rect = this.$el.getBoundingClientRect()
    this.stickyForHeight = rect.top - this.stickyTop + 2
  }

  //产后护理才会出现高度折叠变化
  @Watch('stickyTop')
  getStickyTop(current: number, old: number) {
    this.stickyTopForClassifyHeight = current + this.tabHeight //必须加上一个tabs
    if (this.isFixed && old > current) {
      //解决吸顶高度变小后的问题
      window.scrollTo(0, this.scrollTopNoFix)
    }
    if (this.isFixed && old < current) {
      //解决吸顶高度变大后的问题
      window.scrollBy(0, old - current)
    }
  }

  //产后恢复专用
  @Watch('query')
  queryChange() {
    if (this.isFixed) {
      //列表滑动到顶部 防止遮挡列表前面的item
      if (this.isRecover) {
        window.scrollTo(0, this.scrollTopNoFix)
      } else {
        window.scrollTo(0, this.stickyForHeight)
      }
    }
  }

  scrolling(params: any) {
    const { isFixed, scrollTop } = params
    if (!isFixed) {
      this.scrollTopNoFix = scrollTop
    }
    this.isFixed = isFixed
    isFixed ? (this.normalColor = '#ffffff') : (this.normalColor = 'transparent')
  }

  ////解决兼容性问题
  beforeChange(name: string) {
    const a = document.getElementsByClassName('van-dropdown-menu__bar--opened')
    if (a.length > 0) {
      return false
    }
    return true
  }

  //跳转tab
  tabClicked(idx: number) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_tab, positionParam: { citycode: getSelectedCityId(), tabname: 0 == this.tabSelect ? '商家' : '商品' } })
  }
}
